import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

const routeRecord: RouteRecordRaw[] = [
  {
    name: 'client.children.registration',
    path: 'children/registration',
    component: () => import('src/client/pages/children/Registration.vue'),
    meta: {
      roles: [Roles.Client],

      supportedPlatforms: ['desktop', 'mobile', 'native'],
      excludeEnv: [],
    },
  },
  {
    name: 'client.children.registration.new',
    path: 'children/registration/:studentId/new',
    component: () =>
      import('src/client/pages/children/NewRegistrationForm.vue'),
    meta: {
      roles: [Roles.Client],

      supportedPlatforms: ['desktop', 'mobile', 'native'],
      excludeEnv: [],
    },
  },
  {
    name: 'client.children.attendance',
    path: 'children/attendance',
    component: () => import('src/client/pages/children/ClientAttendance.vue'),
    meta: {
      roles: [Roles.Client],

      supportedPlatforms: ['desktop', 'mobile', 'native'],
      excludeEnv: [],
    },
  },
  {
    name: 'client.children.rsvp',
    path: 'children/rsvp',
    component: () => import('src/client/pages/children/ClientRSVP.vue'),
    meta: {
      roles: [Roles.Client],

      supportedPlatforms: ['desktop', 'mobile', 'native'],
      excludeEnv: [],
    },
  },
]

export default routeRecord
